<div class="container-fluid h-full">
  <div class="row h-full">
    @if (first) {
      <div class="col md:col-6 md:mb-0 h-full" id="catalog_compare_wrp_compare-item-first">
        <mat-card class="h-full">
          <cat-detail-item [detailItem]="first" class="h-full"></cat-detail-item>
        </mat-card>
      </div>
    }

    @if (second) {
      <div class="col md:col-6 md:mb-0 h-full" id="catalog_compare_wrp_compare-item-second">
        <mat-card class="h-full">
          <cat-detail-item [detailItem]="second" class="h-full"></cat-detail-item>
        </mat-card>
      </div>
    }
  </div>
</div>
